import * as React from "react";

function SvgRecMobileHeaderSetumei(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
      <circle cx={11} cy={11} r={11} fill="#fff" />
      <g fill="#f2a7b3">
        <path d="M18.055 9.409a9.988 9.988 0 00-14.11 0 .74.74 0 101.045 1.045 8.51 8.51 0 0112.02 0 .74.74 0 101.045-1.045z" />
        <path d="M6.558 12.022a.739.739 0 001.045 1.045 4.81 4.81 0 016.794 0 .74.74 0 101.045-1.045 6.288 6.288 0 00-8.884 0zM9.013 15.522L11 17.51l1.987-1.986a2.81 2.81 0 00-3.974 0z" />
      </g>
    </svg>
  );
}

export default SvgRecMobileHeaderSetumei;
